import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

function normalizeValue(value) {
  if (value === null || value === undefined) return '';
  if (typeof value === 'boolean') return value ? 'Sí' : 'No';
  if (value instanceof Date) return value.toLocaleString('es-MX');
  return String(value);
}

function buildSheetRows(columns, rows) {
  return rows.map((row) => {
    const output = {};
    columns.forEach((col) => {
      output[col.label] = normalizeValue(row[col.key]);
    });
    return output;
  });
}

function loadImage(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = url;
  });
}

export function exportReportToExcel({ columns, rows, fileName = 'reporte' }) {
  const data = buildSheetRows(columns, rows);
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(data);
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Reporte');
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
}

export async function exportReportToPdf({
  title,
  subtitle = '',
  columns,
  rows,
  fileName = 'reporte',
  logoUrl = '',
}) {
  const doc = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });
  const now = new Date().toLocaleString('es-MX');
  const marginX = 36;

  doc.setFillColor(21, 24, 36);
  doc.rect(0, 0, doc.internal.pageSize.getWidth(), 84, 'F');

  if (logoUrl) {
    try {
      const logo = await loadImage(logoUrl);
      doc.addImage(logo, 'PNG', marginX, 20, 120, 42);
    } catch {
      // Ignorar error de logo para no bloquear el PDF.
    }
  }

  doc.setTextColor(255, 255, 255);
  doc.setFontSize(16);
  doc.text(title || 'Reporte', marginX + 132, 38);
  doc.setFontSize(10);
  doc.text(subtitle || 'Reporte generado desde Nexyo', marginX + 132, 56);
  doc.text(`Generado: ${now}`, doc.internal.pageSize.getWidth() - marginX - 180, 38);
  doc.text(`Registros: ${rows.length}`, doc.internal.pageSize.getWidth() - marginX - 180, 56);

  const head = [columns.map((col) => col.label)];
  const body = rows.map((row) => columns.map((col) => normalizeValue(row[col.key])));

  autoTable(doc, {
    startY: 104,
    head,
    body,
    styles: {
      fontSize: 9,
      cellPadding: 6,
      textColor: [42, 52, 64],
      lineColor: [226, 232, 240],
      lineWidth: 0.5,
    },
    headStyles: {
      fillColor: [251, 201, 3],
      textColor: [21, 24, 36],
      fontStyle: 'bold',
    },
    alternateRowStyles: {
      fillColor: [248, 250, 252],
    },
    margin: { left: marginX, right: marginX },
  });

  doc.save(`${fileName}.pdf`);
}

